<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
    <section class="container request-access-container tab-container">
        <section class="template-section-title">
			<div class="breadcrumb-container">
                <span>My Plan <i class="fa fas fa-chevron-right"></i></span> 
                <app-breadcrumb [pageName]="'Request Access'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Access a Locked Plan</h1>
			</div>
		</section>
        <div class="notification-bubble-container">
            <app-notification-bubble></app-notification-bubble>
        </div>

        <section class="dynamic-collapse">
            <section class="dynamic-collapse-header">
                <h3 class="col">Please Read The Steps Below</h3> 
                <input type="button" class="col-sm-2 desktop-notify-us btn btn-primary primary-default-btn" value="Notify Us" (click)="onSelect()">
            </section>
            <section class="dynamic-collapse-main">
                <div class="dynamic-collapse-content">
                    <div class="request-access-explanations">If a plan owner has passed away or lost mental capacity, you can request that we unlock the parts of their plan which you were delegated future access to.</div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="title-section">
                                <div class="circle">1</div>
                                <div class="title">Notify</div>
                            </div>
                            <div class="content">Click on the ‘Notify Us’ button above. We will ask you for some details regarding the plan owner's death or loss of capacity.</div>
                        </div>
                        <div class="col-md-4">
                            <div class="title-section">
                                <div class="circle">2</div>
                                <div class="title">Verify</div>
                            </div>
                            <div class="content">Before we make the plan available for you to view, we will carry out a few checks to help us verify your request.</div>
                        </div>
                        <div class="col-md-4">
                            <div class="title-section">
                                <div class="circle">3</div>
                                <div class="title">Unlock</div>
                            </div>
                            <div class="content">Once we are happy with your request, we will notify you that the plan is available for you to view in line with the plan owner's wishes.</div>
                        </div>
                        <div class="mobile-notify-us">
                            <input type="button" value="Notify Us" class="btn col-12 btn-primary primary-default-btn" (click)="onSelect()">
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </section>
</section>